import { Category, Supabase } from '@firmable/contracts';
import { useQuery } from '@tanstack/react-query';
import { Query } from '@web/constants/query';
import { Download } from '@web/constants/download';
import { useDownloadHistory as useDownloadHistoryStore } from '@web/store/DownloadCenter/List/useDownloadHistory';
import axios from 'axios';
export interface Failure {
  message: string;
}

type GetDownloadsResponse = {
  records: Supabase.Customer.DownloadHistory[];
  total: number;
};

interface DownloadHistoryFilterParams {
  from: number;
  size: number;
  type: Supabase.Inngest.DownloadType | null;
  category: Category | null;
  status: Supabase.Inngest.DownloadStatus[] | null;
  requestId: string | null;
  userId: string | null;
}

/**
 * React Query hook to get all the downloads for the customer
 * @returns GetDownloadsResponse | undefined
 */
const useDownloadHistory = () => {
  const { pageIndex, pageSize, selectedDownloadType, selectedCategory, selectedStatus, requestIdFilter, userIdFilter } =
    useDownloadHistoryStore();

  const from = pageSize * pageIndex;
  const size = pageSize;

  const filterParams: DownloadHistoryFilterParams = {
    from,
    size,
    type: selectedDownloadType,
    category: selectedCategory ? (selectedCategory.toLowerCase() as Category) : null,
    status: selectedStatus ? Download.statusKeys[selectedStatus] : null,
    requestId: requestIdFilter?.trim().toLowerCase() ?? null,
    userId: userIdFilter,
  };

  return useQuery({
    queryKey: [Query.SupabaseKeys.downloads, { ...filterParams }],
    refetchOnWindowFocus: false,
    retry: false,
    refetchInterval: from === 0 ? 15000 : false,
    placeholderData: (previousData) => previousData,
    //staleTime: from === 0 ? 15000 : Infinity,
    queryFn: async () => {
      const response = await axios.post<GetDownloadsResponse>(
        `${process.env.NEXT_PUBLIC_API_APP_ENDPOINT}/download/history`,
        filterParams,
      );

      return response.data;
    },
  });
};

export { useDownloadHistory };
